export const genericModalI18NDe = {
    cancel: "Abbrechen",
    ok: "OK",
    reset: "Zurücksetzen",
};
